// Lets code outside the React tree (namely the axios response interceptor in api.js)
// trigger a route change. react-router-dom's useNavigate() only works inside components,
// so NavigationBridge (rendered once near the app root) hands its navigate function to this
// module-level ref, which anything can then call.
let navigateRef = null;

const NavigationService = {
  setNavigate(navigate) {
    navigateRef = navigate;
  },
  navigate(to, options) {
    if (navigateRef) {
      navigateRef(to, options);
    } else {
      // Router hasn't mounted yet (or somehow unmounted) - fall back to a full navigation
      // rather than silently dropping it.
      window.location.assign(to);
    }
  },
};

export default NavigationService;
